<template>
	<div>
		<div v-show="this.error" >
			<div v-if="this.filtroGrid">
				<v-card style="text-align: center;" class="mb-2" >
					<v-btn
						small
						block
						@click="setShowFiltro"
            color="#FFFFFF"
					>
						<v-icon >filter_list</v-icon>
						<span>filtros</span>
					</v-btn>
				</v-card>
				<v-expand-transition>
					<v-card v-if="showFiltro"
						class="transition-slow-in-slow-out"
						style="height: 100%;"
					>
						<div class="grid-form-filtro" >
							<div class="grid-form-filtro-inputs"
								v-for="(c, i) in colunas"
								:key="i"
								v-if="!(c.filtable==false)">
								<Input style="width: 100%" type="text" :label="c.text" v-model.trim="form[(c.sub_value)?c.sub_value:c.value]" />
							</div>
						</div>
						<div style="padding:5px">
							<v-btn small
							  dark
							  class="second"
							  @click="montabusca"
							>
							<v-icon>search</v-icon>
							<span>Pesquisar</span>
							</v-btn>
						</div>
					</v-card>
				</v-expand-transition>
			</div>
			<div v-if="this.ordemGrid">
				<v-card>
					<v-btn
						small
						block
						@click="setShowOrdem"
            color="#FFFFFF"
					>
						<v-icon >format_list_numbered</v-icon>
						<span>ordem</span>
					</v-btn>
				</v-card>
				<v-expand-transition>
					<v-card v-if="showOrdem"
						class="transition-slow-in-slow-out"
						style="height: 100%;"
					>
						<div class="grid-form-filtro" >
							<div class="grid-form-filtro-inputs">
								<div d-block v-for="(c, i) in colunas"
									:key="i.key"
									v-if="!(c.ordable==false)">
									<CheckBox
										:label="c.text"
										:val="(c.sub_value)?c.sub_value:c.value"
										v-model="column">
									</CheckBox>
								</div>
								<div d-block v-for="(c, i) in column" :key="i.key">
										<label v-for="(c2, i) in colunas"
										:key="i.key" v-if="c2.value == c">
										{{ c2.text }}
										</label>
										<Radio v-model="sorted[i]" val="asc" label="Ascendente"/>
										<Radio v-model="sorted[i]" val="desc" label="Descendente"/>
								</div>
							</div>
						</div>
						<div style="padding:5px">
							<v-btn small
							  dark
							  class="second"
								@click="montabusca"
							>
								<v-icon>format_list_numbered</v-icon>
								<span>Ordenar</span>
							</v-btn>
						</div>
					</v-card>
				</v-expand-transition>
			</div>
			<v-data-table :headers="colunas"
			  :items="dados.data"
			  hide-default-footer
			  :loading="loading"
			>
				<v-progress-linear slot="progress" color="nav-bar-sub" height="2" indeterminate></v-progress-linear>
				<template slot="items" slot-scope="props">
					<td v-for="(coluna, i) in colunas"
					:key=i>
						<ul v-if="Array.isArray(props.item[coluna.value])">
							<li v-for="(sub, index) in props.item[coluna.value]" :key="index">
								{{sub[coluna.sub_value]}}
							</li>
						</ul>
						<span v-else>
							{{ props.item[coluna.value] }}
						</span>
					</td>
				</template>
			</v-data-table>
		<div v-if="paginacaoBar" class="paginacao" xs12>
			<v-flex xs3 d-flex>
				<span v-if="totalPorPag">Total de Itens: <b>{{dados.total}}</b></span>
			</v-flex >
			<v-flex xs3 d-flex>
				<span v-if="itensPorPag">Itens por página: <b>{{dados.per_page}}</b></span>
			</v-flex>
			<v-flex xs3 d-flex>
				<span v-if="paginacaoNav">Página: <b>{{dados.current_page}}</b> de {{dados.last_page}}</span>
			</v-flex>
			<v-flex xs3
							style="text-align: left"
			>
				<v-btn v-if="paginacaoNav"
							icon
							color="nav-bar-sub"
							@click="getDados(dados.prev_page_url)"
							:disabled="!dados.prev_page_url"
				>
					<v-icon>keyboard_arrow_left</v-icon>
				</v-btn >
				<v-btn v-if="paginacaoNav"
							icon
							color="nav-bar-sub"
							@click="getDados(dados.next_page_url)"
							:disabled="!dados.next_page_url"
				>
					<v-icon>keyboard_arrow_right</v-icon>
				</v-btn >
			</v-flex>
		</div>
		</div>
		<div v-show="!this.error">
			<v-alert
				:value="true"
				type="error"
			>
				Dados não encontrados :(
			</v-alert>
		</div>
	</div>
</template>

<script>
import api from '@/api';
import Input from '@/components/Input';
import CheckBox from '@/components/CheckBox';
import Radio from '@/components/Radio';

export default {
  name: 'DataGrid',
  components: {
    Input,
    CheckBox,
    Radio,
  },
  props: {
    colunas: Array,
    urlPagina: String,
    filtroGrid: {
      type: Boolean,
      default: true,
    },
    ordemGrid: {
      type: Boolean,
      default: true,
    },
    paginacaoBar: {
      type: Boolean,
      default: true,
    },
    totalPorPag: {
      type: Boolean,
      default: true,
    },
    itensPorPag: {
      type: Boolean,
      default: true,
    },
    paginacaoNav: {
      type: Boolean,
      default: true,
    },
    queryParams: {
        type: String,
        default: ''
      }
  },
  data: () => ({
    dados: {},
    loading: true,
    error: true,
    form: {},
    filtro: '?',
    ordem: '',
    showFiltro: false,
    showOrdem: false,
    column: [],
    sorted: [],
  }),
  mounted() {
    this.getDados();
  },
  methods: {
    async getDados(page_url) {
      this.loading = true;
      page_url = page_url || this.urlPagina;

	  let param = '';
      if (page_url.indexOf("?") > 0 ){
          param = page_url.split("?");          
          page_url = this.urlPagina + "?" + param[1];
      }

      if(this.queryParams) page_url += `?${this.queryParams}`

      try {
        const { data } = await api.get(page_url);
        this.dados = data.results;
        this.loading = false;
      } catch (e) {
        this.error = false;
        console.log('error');
      }
    },
    pesquisar() {
      if (this.colunas) {
        for (const c of this.colunas) {
          const nomeCampo = (c.sub_value) ? c.sub_value : c.value;
          if (this.form[nomeCampo] && !(c.filtable == false)) { this.filtro += `${nomeCampo}=${this.form[nomeCampo]}&`; }
        }
      }
      this.getDados(this.urlPagina + this.filtro + this.queryParams  + this.ordem);
    },
    ordenar() {
      if (this.colunas) {
        const col = this.column;
        const sort = this.sorted;
        for (const key in col) {
          if (col.hasOwnProperty(key)) {
            this.ordem += `column[${key}]=${col[key]}&`;
            this.ordem += `sorted[${key}]=${sort[key]}&`;
          }
        }
      }
      // console.log(this.ordem)
      this.getDados(this.urlPagina + this.filtro + this.ordem);
      // this.ordem =''
    },
    montabusca() {
      this.pesquisar();
      this.ordenar();
      //	console.log(this.urlPagina)

      this.ordem = '';
      this.filtro = '?';
    },
    setShowFiltro() {
      this.showFiltro = !this.showFiltro;
    },
    setShowOrdem() {
      this.showOrdem = !this.showOrdem;
    },

  },
};
</script>

<style lang="scss">

.paginacao{
	display: flex;
	flex-wrap: wrap;

  background-color: white;
  padding: 1%;
  font-size: 12px;
  text-align: right;
  color: #909090;
  border-top: 1px solid #e0e0e0;

  span{
		margin-right: 29px;
		padding: 15px 0 0 0;
    text-align: right;

    b{
      margin-left: 5px;
      font-weight: normal;
    }
  }
}

.grid-form-filtro{
	display: flex;
  flex-wrap: wrap;
  padding-top: 5px;

	.grid-form-filtro-inputs{
		flex: 0 0 50%;
		padding: 5px 4px 0px 4px
	}
}

</style>
